import React from "react";
import logoUrl from "../assets/logo.svg";

interface HeroProps {
  showShopButton?: boolean;
}

const Hero: React.FC<HeroProps> = ({showShopButton = true}) => {
  return (
    <section className="text-center py-16 relative min-h-[30vh] md:min-h-[40vh] lg:min-h-[50vh] flex items-center justify-center">
      <h1 className="sr-only">Hallie Parker INDIE AUTHOR</h1>
      <div className="w-full px-4">
        <img
          src={logoUrl}
          alt="Hallie Parker — Indie Author"
          decoding="async"
          fetchPriority="high"
          className="mx-auto w-full h-auto max-w-[90vw] sm:max-w-2xl md:max-w-4xl lg:max-w-5xl xl:max-w-6xl"
        />
      </div>
      {showShopButton && (
        <div className="absolute bottom-2 right-4 sm:bottom-3 sm:right-6 md:bottom-4 md:right-8 lg:bottom-8 lg:right-8">
          <a
            href="/shop"
            className="btn btn-outline inline-flex items-center text-xs px-2 py-1 sm:text-sm sm:px-3 sm:py-1.5 md:text-base md:px-4 md:py-2"
          >
            Visit Shop
            <svg
              className="ml-1 sm:ml-2 h-3 w-3 sm:h-4 sm:w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              />
            </svg>
          </a>
        </div>
      )}
    </section>
  );
};

export default Hero;
